import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
	
	window.scrollTo(0, 0);

    return {
        type: 'INCUBACAO_MATURIDADE_ANO2_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'INCUBACAO_MATURIDADE_ANO2_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('incubacaoMaturidadeAno2Form', registro)
    ];
}

export function getLista() {
	const request = axios.get(`${consts.API_URL}/incubacaoMaturidade`);
	return {
		type: 'INCUBACAO_MATURIDADE_ANO2_LISTADO',
		payload: request
	};
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/incubacaoMaturidade`, {
				...registro,
				ano: 2,
				financeiro_cac: FormatUtils.formatarValorBanco(registro.financeiro_cac, 2),
				financeiro_faturamento: FormatUtils.formatarValorBanco(registro.financeiro_faturamento, 2),
				financeiro_custo_fixo: FormatUtils.formatarValorBanco(registro.financeiro_custo_fixo, 2),
				financeiro_custo_variavel: FormatUtils.formatarValorBanco(registro.financeiro_custo_variavel, 2),
				financeiro_lucro: FormatUtils.formatarValorBanco(registro.financeiro_lucro, 2),
				financeiro_investimento: FormatUtils.formatarValorBanco(registro.financeiro_investimento, 2),
				mercado_propspects: FormatUtils.formatarValorBanco(registro.mercado_propspects, 0),
				mercado_clientes: FormatUtils.formatarValorBanco(registro.mercado_clientes, 0),
				mercado_satisfacao: FormatUtils.formatarValorBanco(registro.mercado_satisfacao, 2),
				mercado_recorrencia: FormatUtils.formatarValorBanco(registro.mercado_recorrencia, 2),
				gestao_metas: FormatUtils.formatarValorBanco(registro.gestao_metas, 2),
				inovacao_editais: FormatUtils.formatarValorBanco(registro.inovacao_editais, 2),
				pessoas_colaboradores: FormatUtils.formatarValorBanco(registro.pessoas_colaboradores, 0),
				pessoas_dedicacao: FormatUtils.formatarValorBanco(registro.pessoas_dedicacao, 0),
				pessoas_horas: FormatUtils.formatarValorBanco(registro.pessoas_horas, 0),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/incubacaoMaturidade`, {
				...registro,
				financeiro_cac: FormatUtils.formatarValorBanco(registro.financeiro_cac, 2),
				financeiro_faturamento: FormatUtils.formatarValorBanco(registro.financeiro_faturamento, 2),
				financeiro_custo_fixo: FormatUtils.formatarValorBanco(registro.financeiro_custo_fixo, 2),
				financeiro_custo_variavel: FormatUtils.formatarValorBanco(registro.financeiro_custo_variavel, 2),
				financeiro_lucro: FormatUtils.formatarValorBanco(registro.financeiro_lucro, 2),
				financeiro_investimento: FormatUtils.formatarValorBanco(registro.financeiro_investimento, 2),
				mercado_propspects: FormatUtils.formatarValorBanco(registro.mercado_propspects, 0),
				mercado_clientes: FormatUtils.formatarValorBanco(registro.mercado_clientes, 0),
				mercado_satisfacao: FormatUtils.formatarValorBanco(registro.mercado_satisfacao, 2),
				mercado_recorrencia: FormatUtils.formatarValorBanco(registro.mercado_recorrencia, 2),
				gestao_metas: FormatUtils.formatarValorBanco(registro.gestao_metas, 2),
				inovacao_editais: FormatUtils.formatarValorBanco(registro.inovacao_editais, 2),
				pessoas_colaboradores: FormatUtils.formatarValorBanco(registro.pessoas_colaboradores, 0),
				pessoas_dedicacao: FormatUtils.formatarValorBanco(registro.pessoas_dedicacao, 0),
				pessoas_horas: FormatUtils.formatarValorBanco(registro.pessoas_horas, 0),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/incubacaoMaturidade?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}